import * as React from "react";
import {
  Typography,
  styled,
  Paper,
  Grid,
  Fade,
  Button,
  Link,
  Box,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import {
  FolderOpen as ProjectIcon,
  ContactPhone as PeopleIcon,
  Business as BuildingIcon,
} from "@mui/icons-material";

// Import the new dashboard table components
import { DashboardBuildingsTable } from "../components/DashboardBuildingsTable";
import { DashboardJobsTable } from "../components/DashboardJobsTable";
import { DashboardContactsTable } from "../components/DashboardContactsTable";

const Item = styled(Paper)(({ theme }) => {
  return {
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2),
    background: theme.palette.secondary.main,
  };
});

export const Dashboard = (props) => {
  const navigate = useNavigate();

  const getGreeting = () => {
    const myDate = new Date();
    const hrs = myDate.getHours();

    let greet;

    if (hrs < 12) greet = "Good morning";
    else if (hrs >= 12 && hrs <= 17) greet = "Good afternoon";
    else if (hrs >= 17 && hrs <= 24) greet = "Good evening";

    return greet;
  };

  const handleLink = (destination) => {
    navigate(destination);
  };

  return (
    <Fade in={true}>
      <div>
        <Typography
          style={{ marginBottom: "20px", textTransform: "uppercase" }}
          align="left"
          variant="h4"
        >
          {getGreeting() + ", " + props.user.displayName}
        </Typography>

        <Box sx={{ mb: 4, p: 2, backgroundColor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
          <DashboardBuildingsTable />
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => handleLink("/buildings")}
            startIcon={<BuildingIcon />}
          >
            View all Buildings
          </Button>
        </Box>

        <Box sx={{ mb: 4, p: 2, backgroundColor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
          <DashboardJobsTable />
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => handleLink("/projects")}
            startIcon={<ProjectIcon />}
          >
            View all Jobs
          </Button>
        </Box>

        <Box sx={{ mb: 4, p: 2, backgroundColor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
          <DashboardContactsTable />
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => handleLink("/contacts")}
            startIcon={<PeopleIcon />}
          >
            View all Contacts
          </Button>
        </Box>
      </div>
    </Fade>
  );
};